import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker", "input"]

  syncFromPicker() {
    this.inputTarget.value = this.pickerTarget.value
  }

  syncFromInput() {
    const value = this.inputTarget.value
    if (/^#[0-9A-Fa-f]{6}$/.test(value)) {
      this.pickerTarget.value = value
    }
  }
}
